import { IMRElementSizeWatchController } from "./element-size-watch.controller"


export const DIRECTIVE_NAME: string = 'imrElementSizeWatch'

export class IMRElementSizeWatchDirective implements ng.IDirective {

    controller = ['$scope', '$element', ($scope: ng.IScope, $element: JQuery) => new IMRElementSizeWatchController($scope, $element)]
  
    restrict = 'A'
    
    scope = {
        [DIRECTIVE_NAME]: '='
    }

}
